import React from 'react'
import './../../assets/css/loader.css'

const Loader = () => {
    return (
        <div className="loader" id="loader-6">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    )
}

export default Loader